/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialDays: NonNullable<unknown>, amount: NonNullable<unknown> }} Funnel_Finish_Terms_YearInputs */

const en_funnel_finish_terms_year = /** @type {(inputs: Funnel_Finish_Terms_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} days free, then $${i?.amount}/year. Cancel before the trial ends and you won't be charged.`)
};

const es_funnel_finish_terms_year = /** @type {(inputs: Funnel_Finish_Terms_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trialDays} días gratis, luego $${i?.amount} al año. Si cancelas antes de que termine la prueba, no se te cobrará.`)
};

/**
* | output |
* | --- |
* | "{trialDays} days free, then ${amount}/year. Cancel before the trial ends and you won't be charged." |
*
* @param {Funnel_Finish_Terms_YearInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_finish_terms_year = /** @type {((inputs: Funnel_Finish_Terms_YearInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Finish_Terms_YearInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_finish_terms_year(inputs)
	return en_funnel_finish_terms_year(inputs)
});